import { render, staticRenderFns } from "./HomeParallax.vue?vue&type=template&id=1aeb2faf&scoped=true&"
import script from "./HomeParallax.vue?vue&type=script&lang=js&"
export * from "./HomeParallax.vue?vue&type=script&lang=js&"
import style0 from "./HomeParallax.vue?vue&type=style&index=0&id=1aeb2faf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb2faf",
  null
  
)

export default component.exports